import { render, staticRenderFns } from "./DataTableInteractive.vue?vue&type=template&id=ea677020&"
import script from "./DataTableInteractive.vue?vue&type=script&lang=js&"
export * from "./DataTableInteractive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports